import React from 'react';
import { ArrowDownToLine, FilePlus2, FileUp, Film, ListOrdered, Network, Terminal } from 'lucide-react';

export type EditorMode = 'beginner' | 'advanced';

interface AppHeaderProps {
  mode: EditorMode;
  projectName: string;
  saveState: 'saved' | 'saving' | 'error';
  savedTime: string;
  onModeChange: (mode: EditorMode) => void;
  onNameChange: (name: string) => void;
  onNew: () => void;
  onImportConfig: () => void;
  onExportConfig: () => void;
  onImportCommand: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ mode, projectName, saveState, savedTime, onModeChange, onNameChange, onNew, onImportConfig, onExportConfig, onImportCommand }) => (
  <header className="app-header">
    <div className="brand-lockup">
      <span className="brand-mark"><Film size={17} /></span>
      <div className="brand-wordmark"><strong>FFmpeg</strong><span>WORKFLOW</span></div>
      <span className="header-divider" />
      <label className="project-name-field">
        <span className="sr-only">工作流名称</span>
        <input name="workflow-name" value={projectName} onChange={(event) => onNameChange(event.target.value)} aria-label="工作流名称" />
      </label>
      <span className={'save-indicator' + (saveState === 'error' ? ' save-indicator--error' : '')} aria-live="polite">
        <i />{saveState === 'saving' ? '保存中' : saveState === 'error' ? '未保存' : savedTime ? '已保存 ' + savedTime : '已自动保存'}
      </span>
    </div>
    <div className="header-center">
      <div className="mode-switch" role="tablist" aria-label="编辑模式">
        <button type="button" role="tab" aria-selected={mode === 'beginner'} className={mode === 'beginner' ? 'is-active' : ''} onClick={() => onModeChange('beginner')}>
          <ListOrdered size={16} /><span>初级模式</span>
        </button>
        <button type="button" role="tab" aria-selected={mode === 'advanced'} className={mode === 'advanced' ? 'is-active' : ''} onClick={() => onModeChange('advanced')}>
          <Network size={16} /><span>高级模式</span>
        </button>
      </div>
    </div>
    <div className="header-actions">
      <button className="header-action" type="button" onClick={onImportCommand}><Terminal size={16} /><span>导入命令</span></button>
      <button className="header-action" type="button" onClick={onImportConfig}><FileUp size={16} /><span>导入配置</span></button>
      <button className="header-action" type="button" onClick={onExportConfig}><ArrowDownToLine size={16} /><span>导出配置</span></button>
      <button className="header-new" type="button" onClick={onNew}><FilePlus2 size={15} /><span>新建</span></button>
    </div>
  </header>
);

export default AppHeader;
